import { Navigate, Outlet, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  isAuthenticated: boolean;
}

const ProtectedRoute = ({ isAuthenticated }: ProtectedRouteProps) => {
  const location = useLocation();

 if (!isAuthenticated) {
  if (location.pathname !== "/logout") {
    localStorage.setItem("lastPath", location.pathname);
  }
  return <Navigate to="/login" replace />;
}

  return <Outlet />;
};

export default ProtectedRoute;
